<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="container has-text-centered">
          <img width="25%" src="@/assets/logo2.png" alt="Logo" />
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="box">
          <div v-show="pase === 0">
            <center>
              <h1 class="title has-text-dark">CL7- CLIMA LABORAL</h1>
            </center>
            <br />
            <h1 class="title is-4">¡Hola!</h1>
            <h2 class="subtitle is-5">
              <strong>{{ employeeresponded.nombre }}</strong>
            </h2>
            <div class="has-text-left">
              <p>
                Antes de que inicies, es importante que sepas que tu
                participación es voluntaria, no se reportarán resultados
                individuales y tus respuestas se manejarán de manera
                confidencial y según la normatividad vigente en Colombia (en
                especial la Ley 1581 de 2012).
              </p>
              <br />
              <p>
                *Estos datos podrán ser usados por Siete S.A.S. para
                investigación, manteniendo la confidencialidad de los mismos.
              </p>
              <br />
              <p>
                Teniendo en cuenta estas condiciones das tu consentimiento para
                continuar
              </p>
              <br />
            </div>
            <div class="control">
              <div class="field">
                <input
                  class="is-checkradio is-dark"
                  type="radio"
                  id="agreeyes"
                  :value="true"
                  v-model="responses.agree"
                />
                <label for="agreeyes" class="is-capitalized">Sí</label>
                <input
                  class="is-checkradio is-dark"
                  type="radio"
                  id="agreeno"
                  :value="false"
                  v-model="responses.agree"
                />
                <label for="agreeno" class="is-capitalized">No</label>
              </div>
            </div>
            <br />
            <div class="has-text-centered">
              <button
                v-show="responses.agree"
                @click="next()"
                class="button is-dark"
                :disabled="!responses.agree"
              >
                Siguiente
              </button>
              <button
                v-show="!responses.agree"
                @click="endno()"
                class="button is-dark"
              >
                Terminar y Guardar
              </button>
            </div>
          </div>
          <div v-show="pase === 1">
            <strong>Instrucciones:</strong>
            <br />
            <br />
            <p>
              A continuación encontrarás distintas frases sobre tu organización,
              tu trabajo o tu jefe inmediato. Lee cada una con atención y
              expresa tu nivel de acuerdo. No te preocupes que no hay respuestas
              buenas o malas, todas serán valiosas para nuestro proceso de
              mejoramiento si reflejan bien lo que piensas. Así que entre más
              honesto(a) seas, más nos ayudas.
            </p>
            <br />
            <br />
            <div class="field has-text-centered">
              <!-- <button @click="prev()" class="button has-background-grey-light">
                Anterior
              </button> -->
              <button @click="next()" class="button is-dark">Siguiente</button>
            </div>
          </div>
          <div v-show="pase === 2">
            <div v-if="isMovil">
              <div v-for="(question, index) in displayedQuestions" :key="index">
                <strong>{{ question.numeroPregunta }}.</strong>
                <span>
                  {{ question.question }}
                </span>
                <table style="width: 100%">
                  <tr>
                    <td colspan="2" style="font-size: 10px">
                      Completamente <br />
                      de acuerdo
                    </td>
                    <td></td>
                    <td
                      class="has-text-right"
                      colspan="2"
                      style="font-size: 10px"
                    >
                      Completamente <br />
                      en desacuerdo
                    </td>
                    <td class="has-text-right" style="font-size: 10px">
                      No sé
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <center>
                        <input
                          :id="question.codigo + '05'"
                          type="radio"
                          v-model="responses[question.codigo]"
                          value="5"
                        />
                      </center>
                    </td>
                    <td>
                      <center>
                        <input
                          type="radio"
                          :id="question.codigo + '04'"
                          value="4"
                          v-model="responses[question.codigo]"
                        />
                      </center>
                    </td>
                    <td>
                      <center>
                        <input
                          type="radio"
                          :id="question.codigo + '03'"
                          value="3"
                          v-model="responses[question.codigo]"
                        />
                      </center>
                    </td>
                    <td>
                      <center>
                        <input
                          type="radio"
                          :id="question.codigo + '02'"
                          value="2"
                          v-model="responses[question.codigo]"
                        />
                      </center>
                    </td>
                    <td>
                      <center>
                        <input
                          type="radio"
                          :id="question.codigo + '01'"
                          value="1"
                          v-model="responses[question.codigo]"
                        />
                      </center>
                    </td>
                    <td>
                      <center>
                        <input
                          type="radio"
                          :id="question.codigo + '00'"
                          value="0"
                          v-model="responses[question.codigo]"
                        />
                      </center>
                    </td>
                  </tr>
                </table>
                <hr />
              </div>
            </div>
            <div v-if="!isMovil">
              <div class="columns">
                <div class="column is-4"></div>
                <div class="column">
                  <center>
                    <label class="has-text-dark"
                      >Completamente de acuerdo</label
                    >
                  </center>
                </div>
                <div class="column">
                  <center>
                    <label class="is-capitalized has-text-dark"></label>
                  </center>
                </div>
                <div class="column">
                  <center>
                    <label class="is-capitalized has-text-dark"></label>
                  </center>
                </div>
                <div class="column">
                  <center>
                    <label class="is-capitalized has-text-dark"></label>
                  </center>
                </div>
                <div class="column">
                  <center>
                    <label class="has-text-dark"
                      >Completamente en desacuerdo
                    </label>
                  </center>
                </div>
                <div class="column">
                  <center>
                    <label class="has-text-dark">No sé</label>
                  </center>
                </div>
              </div>
              <div
                class="columns"
                :class="colorback(index)"
                v-for="(question, index) in displayedQuestions"
                :key="index"
              >
                <div class="column is-4">
                  <div class="field has-text-justified">
                    <label class="label"
                      ><strong>{{ question.numeroPregunta }}.</strong>
                      {{ question.question }}</label
                    >
                  </div>
                </div>
                <div class="column">
                  <center>
                    <input
                      required
                      class="is-checkradio is-dark"
                      type="radio"
                      :id="question.codigo + '05'"
                      value="5"
                      v-model="responses[question.codigo]"
                    />
                    <label
                      :for="question.codigo + '05'"
                      class="is-capitalized"
                    ></label>
                  </center>
                </div>
                <div class="column">
                  <center>
                    <input
                      required
                      class="is-checkradio is-dark"
                      type="radio"
                      :id="question.codigo + '04'"
                      value="4"
                      v-model="responses[question.codigo]"
                    />
                    <label
                      :for="question.codigo + '04'"
                      class="is-capitalized"
                    ></label>
                  </center>
                </div>
                <div class="column">
                  <center>
                    <input
                      required
                      class="is-checkradio is-dark"
                      type="radio"
                      :id="question.codigo + '03'"
                      value="3"
                      v-model="responses[question.codigo]"
                    />
                    <label
                      :for="question.codigo + '03'"
                      class="is-capitalized"
                    ></label>
                  </center>
                </div>
                <div class="column">
                  <center>
                    <input
                      required
                      class="is-checkradio is-dark"
                      type="radio"
                      :id="question.codigo + '02'"
                      value="2"
                      v-model="responses[question.codigo]"
                    />
                    <label
                      :for="question.codigo + '02'"
                      class="is-capitalized"
                    ></label>
                  </center>
                </div>
                <div class="column">
                  <center>
                    <input
                      required
                      class="is-checkradio is-dark"
                      type="radio"
                      :id="question.codigo + '01'"
                      value="1"
                      v-model="responses[question.codigo]"
                    />
                    <label
                      :for="question.codigo + '01'"
                      class="is-capitalized"
                    ></label>
                  </center>
                </div>
                <div class="column">
                  <center>
                    <input
                      required
                      class="is-checkradio is-dark"
                      type="radio"
                      :id="question.codigo + '00'"
                      value="0"
                      v-model="responses[question.codigo]"
                    />
                    <label
                      :for="question.codigo + '00'"
                      class="is-capitalized"
                    ></label>
                  </center>
                </div>
              </div>
            </div>

            <progress
              class="progress is-dark is-small"
              :value="(page / numberOfPages) * 100"
              max="100"
            >
              %
            </progress>
            <div class="buttons">
              <button
                type="button"
                @click="
                  page--;
                  scrollTop();
                "
                v-if="page != 1"
                class="button is-is-dark"
              >
                Anterior
              </button>
              <button
                type="button"
                @click="nextquestions"
                v-if="page != numberOfPages"
                class="button is-link"
                :disabled="disabledbutton()"
              >
                Siguiente
              </button>
              <button
                v-if="page === numberOfPages"
                @click="next()"
                class="button is-dark"
                :disabled="disabledbutton1()"
              >
                Siguiente
              </button>
              <br />
            </div>
          </div>
          <div v-show="pase === 3">
            <div class="field">
              <label class="label">Comentarios</label>
              <div class="control">
                <textarea
                  class="textarea"
                  placeholder="Comentarios"
                  v-model="responses.comentarios"
                ></textarea>
              </div>
            </div>
            <div class="buttons">
              <button
                type="button"
                v-show="anteriorshow"
                @click="
                  pase--;
                  scrollTop();
                "
                class="button is-is-dark"
              >
                Anterior
              </button>
              <button class="button is-link" @click="end()">Finalizar</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import apiServices from "@/services/yungol-services";
import apiServices from "@/services/yungol-services-public";
import { mapState } from "vuex";

export default {
  data() {
    return {
      anteriorshow: true,
      employeeresponded: {},
      pase: 0,
      page: 1,
      perPage: 10,
      numberOfPages: 0,
      responses: {
        agree: true,
        comentarios: null,
      },
      questions: [
        {
          codigo: "seg37",
          question:
            "Aquí las personas siguen todos los procedimientos de seguridad y salud en el trabajo.",
        },
        {
          codigo: "comp90",
          question: "Aquí dan mejores beneficios que en otras organizaciones.",
        },
        {
          codigo: "logr66",
          question:
            "En esta organización pareciera que no importa alcanzar los resultados.",
        },
        {
          codigo: "rec102",
          question:
            "En esta organización faltan recursos que son indispensables para hacer el trabajo.",
        },
        {
          codigo: "seg40",
          question:
            "Aquí el trabajo se planea teniendo en cuenta la salud y seguridad de las personas.",
        },
        {
          codigo: "apo21",
          question: "Aquí se ignoran las necesidades de las personas.",
        },
        {
          codigo: "vinc14",
          question: "Las personas están desconectadas de la organización.",
        },
        {
          codigo: "rep74",
          question: "Esta organización es muy bien reconocida en el medio.",
        },
        {
          codigo: "aps1",
          question: "Aquí la gente se ayuda entre sí.",
        },
        {
          codigo: "apo18",
          question:
            "En esta organización se hacen cosas por el bienestar de las personas.",
        },
        {
          codigo: "serv73",
          question:
            "En esta organización se ignoran las necesidades de los clientes/usuarios.",
        },
        {
          codigo: "seg38",
          question:
            "En esta organización los directivos promueven el trabajo seguro.",
        },
        {
          codigo: "lid83",
          question: "Mi jefe coordina bien el trabajo.",
        },
        {
          codigo: "enga108",
          question: "Me siento muy conectado(a) con mi trabajo.",
        },
        {
          codigo: "logr65",
          question:
            "En mi trabajo la gente persiste hasta alcanzar los resultados.",
        },
        {
          codigo: "enga104",
          question: "Me entusiasma mucho mi trabajo.",
        },
        {
          codigo: "logr63",
          question: "Aquí la gente trabaja para alcanzar las metas planteadas.",
        },
        {
          codigo: "exc28",
          question:
            "En esta organización la gente hace las cosas de cualquier manera.",
        },
        {
          codigo: "cyc29",
          question: "Aquí las personas conocen claramente su cargo.",
        },
        {
          codigo: "cyc34",
          question: "Aquí la gente sabe bien qué es lo que debe hacer.",
        },
        {
          codigo: "comp94",
          question: "En esta organización los salarios son justos.",
        },
        {
          codigo: "cyc35",
          question: "Aquí la gente desconoce qué debe hacer.",
        },
        {
          codigo: "cyc31",
          question: "Aquí se siguen las normas.",
        },
        {
          codigo: "rep76",
          question: "A mucha gente le gustaría trabajar en esta organización.",
        },
        {
          codigo: "agi49",
          question: "Esta organización se adapta rápidamente.",
        },
        {
          codigo: "aps2",
          question: "En esta organización las personas ayudan a los demás.",
        },
        {
          codigo: "inn60",
          question: "Aquí nunca se harán las cosas de manera distinta.",
        },
        {
          codigo: "enga109",
          question: "Cuando pienso en mi trabajo me da mucha pereza.",
        },
        {
          codigo: "lid86",
          question: "Mi jefe nos motiva a ser innovadores.",
        },
        {
          codigo: "rec100",
          question:
            "En esta organización tenemos todo lo necesario para hacer bien el trabajo.",
        },
        {
          codigo: "agi53",
          question: "Aquí la gente es lenta para adaptarse a los cambios.",
        },
        {
          codigo: "rep78",
          question:
            "La gente considera que esta es una organización muy buena.",
        },
        {
          codigo: "rec101",
          question:
            "En esta organización, las personas reciben oportunamente sus implementos de trabajo.",
        },
        {
          codigo: "agi52",
          question: "Esta organización se anticipa a los cambios.",
        },
        {
          codigo: "apo17",
          question: "Aquí se aprecian los esfuerzos de la gente.",
        },
        {
          codigo: "aps7",
          question: "En esta organización la gente evita ayudar a otros.",
        },
        {
          codigo: "rep79",
          question: "La organización tiene mala reputación.",
        },
        {
          codigo: "apo20",
          question:
            "En esta organización se respeta la vida extralaboral de las personas.",
        },
        {
          codigo: "lid80",
          question: "Mi jefe es una persona cercana a su equipo.",
        },
        {
          codigo: "exc22",
          question:
            "En esta organización se trabaja pensando en la excelencia.",
        },
        {
          codigo: "aut44",
          question: "Aquí las personas pueden tomar decisiones en su trabajo.",
        },
        {
          codigo: "exc26",
          question: "Aquí la gente trabaja con alta calidad.",
        },
        {
          codigo: "agi51",
          question:
            "En esta organización se actúa rápidamente ante situaciones inesperadas.",
        },
        {
          codigo: "rec98",
          question:
            "En esta organización le dan a la gente lo que necesita para hacer su trabajo.",
        },
        {
          codigo: "aut42",
          question: "Aquí la gente puede hacer las cosas con autonomía.",
        },
        {
          codigo: "inn54",
          question:
            "Aquí se trabaja continuamente para mejorar los procesos y procedimientos.",
        },
        {
          codigo: "inn55",
          question: "En esta organización se crean nuevos productos/servicios.",
        },
        {
          codigo: "aps5",
          question:
            "Aquí la gente encuentra quien le ayude cuando lo necesita.",
        },
        {
          codigo: "serv69",
          question:
            "Satisfacer a los clientes es un objetivo importante para todas las personas de esta organización.",
        },
        {
          codigo: "comp91",
          question: "Aquí los cargos similares tienen beneficios similares.",
        },
        {
          codigo: "logr62",
          question: "En esta organización se definen metas retadoras.",
        },
        {
          codigo: "serv68",
          question:
            "En esta organización se trabaja para satisfacer todas las expectativas de los clientes/usuarios.",
        },
        {
          codigo: "lid88",
          question: "Tengo un mal jefe.",
        },
        {
          codigo: "comp95",
          question: "En mi trabajo hay inequidad salarial.",
        },
        {
          codigo: "enga106",
          question: "El tiempo en mi trabajo se pasa volando.",
        },
        {
          codigo: "exc24",
          question: "En esta organización se reconoce el desempeño excelente.",
        },
        {
          codigo: "aut46",
          question:
            "En esta organización se valora que las personas puedan decidir por sí mismas.",
        },
        {
          codigo: "vinc11",
          question:
            "Las personas se sienten orgullosas de pertenecer a esta organización.",
        },
        {
          codigo: "aut47",
          question:
            "En mi trabajo, las personas deben consultar antes de tomar cualquier decisión.",
        },
        {
          codigo: "vinc10",
          question: "La gente ama trabajar en esta organización.",
        },
        {
          codigo: "inn59",
          question:
            "Aquí constantemente se están buscando formas de hacer mejor las cosas.",
        },
        {
          codigo: "seg41",
          question:
            "En esta organización la seguridad y salud en el trabajo son poco importantes.",
        },
        {
          codigo: "lid87",
          question: "Mi jefe es una persona orientada a los resultados.",
        },
        {
          codigo: "vinc13",
          question: "Las personas se identifican con la organización.",
        },
        {
          codigo: "serv72",
          question:
            "Aquí se conoce muy bien lo que esperan los clientes/usuarios.",
        },
      ],
    };
  },
  computed: {
    ...mapState(["isMovil"]),
    displayedQuestions() {
      return this.paginate(this.questions);
    },
  },
  methods: {
    disabledbutton() {
      const lengthresponses = Object.keys(this.responses).length - 2;
      const numbercuestions = this.page * this.perPage;
      if (lengthresponses >= numbercuestions) {
        return false;
      } else {
        return true;
      }
    },
    disabledbutton1() {
      const lengthresponses = Object.keys(this.responses).length - 2;
      const numbercuestions = this.page * this.perPage;
      if (lengthresponses >= numbercuestions - 5) {
        return false;
      } else {
        return true;
      }
    },
    async findresponded() {
      try {
        const result = await apiServices.get(
          `/employeeresponded/${this.$route.params.id}`
        );
        if (result.data) {
          if (result.data.message) {
            this.$store.dispatch("notify", {
              message: result.data.message,
              type: "is-danger",
              duration: 4000,
              position: "top-center",
            });
            setTimeout(function () {
              window.location.replace("https://sietegho.com");
            }, 5000);
          } else {
            if (result.data.status === "Terminada") {
              this.$router.replace({ name: "finencuestaclima" });
              setTimeout(function () {
                window.location.replace("https://sietegho.com");
              }, 5000);
            } else {
              this.employeeresponded = result.data;
              this.page = result.data.encuesta ? result.data.encuesta.page : 1;
              this.pase = result.data.encuesta ? result.data.encuesta.pase : 0;
              if (result.data.responses) {
                this.responses = result.data.responses;
              }
            }
          }
        }
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message:
            "Ocurrio un error cargando la encuesta. Contáctese con Siete",
          type: "is-danger",
          duration: 4000,
          position: "top-center",
        });
      }
    },
    colorback(index) {
      if (index % 2 === 0) {
        return "colorback";
      } else {
        return null;
      }
    },
    next() {
      this.pase += 1;
      this.saveResponses();
    },
    prev() {
      this.pase -= 1;
    },
    nextquestions() {
      this.page++;
      this.saveResponses();
      this.scrollTop();
    },
    end() {
      //   if (this.checkresponses()) {
      this.saveResponses(true);
      this.$store.dispatch("notify", {
        message: `Perfecto. Encuesta finalizada con éxito`,
      });
      this.$router.replace({ name: "finencuestaclima" });
      setTimeout(function () {
        window.location.replace("https://sietegho.com");
      }, 6000);
      //   }
    },
    endno() {
      this.anteriorshow = false;
      this.pase = 3;
      this.saveResponses(true);
    },
    paginate(questions) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return questions.slice(from, to);
    },
    scrollTop() {
      window.scrollTo({
        behavior: "smooth",
        left: 0,
        top: 200,
      });
    },
    checkresponses() {
      // verifica que todas las preguntas del formulario sean respondidas
      let x = 0;
      let i;
      for (i = 0; i < this.questions.length; i++) {
        // verifica que el objeto responses tenga la propiedad (variable codigo) de cada pregunta
        if (!this.responses.hasOwnProperty(this.questions[i].codigo)) {
          x++;
        }
      }
      if (x > 0) {
        this.$store.dispatch("notify", {
          message: "Aún le falta(n) " + x + " pregunta(s) por responder!",
          type: "is-warning",
          position: "top-center",
        });
        return false;
      } else {
        return true;
      }
    },
    async saveResponses(end) {
      const d = {
        id: this.$route.params.id,
        responses: this.responses,
        encuesta: {
          pase: this.pase,
          page: this.page,
        },
      };
      if (end) {
        d.end = true;
      }
      try {
        await apiServices.post(`/saveresponsesclima`, d);
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message:
            "Ocurrio un error guardando las respuestas. Inténtelo mas tarde.",
          type: "is-danger",
          position: "top-center",
        });
      }
    },
  },
  created() {
    this.findresponded();
    this.numberOfPages = Math.ceil(this.questions.length / this.perPage);
    this.questions.forEach((question, index) => {
      question.numeroPregunta = index + 1;
      return question;
    });
  },
};
</script>

<style lang='scss'>
.logo {
  top: 15px;
  z-index: 31;
  margin-left: 100px;
}
.colorback {
  background-color: #d9d9d9;
  border-radius: 5px;
}
.is-checkradio[type="radio"] + label::before,
.is-checkradio[type="radio"] + label:before,
.is-checkradio[type="checkbox"] + label::before,
.is-checkradio[type="checkbox"] + label:before {
  position: absolute;
  left: 0;
  top: 0rem;
  content: "";
  border: 0.1rem solid #706f6f;
}
.is-checkradio[type="radio"]:checked + label::before,
.is-checkradio[type="radio"]:checked + label:before,
.is-checkradio[type="checkbox"]:checked + label::before,
.is-checkradio[type="checkbox"]:checked + label:before {
  border: 0.1rem solid #706f6f;
}

.borderbox {
  box-shadow: 0 0 0 3px #6600c5, 0 0 0 1px #8000f7;
}
</style>


// WEBPACK FOOTER //
// src/components/clima/EncuestaClima.vue